import {
    CUSTOMER_REFERRALS,
    DISCOUNT_CODE,
    EXHAUSTED_DISCOUNT_CODES,
} from '@/services/promo-codes/constants';
import type {
    CheckDiscountCodeType,
    CheckReferralCodeType,
    GetPromoCodesDataType,
    GetPromoCodesResponseType,
    GetPromoCodesType,
} from '@/services/promo-codes/types';

export const getPromoCodes: GetPromoCodesType = async () =>
    await fetch(EXHAUSTED_DISCOUNT_CODES)
        .then(res => res.json())
        .then((data: GetPromoCodesResponseType): GetPromoCodesDataType => {
            const headers = ['Nazwa akcji', 'Kod promocyjny', 'Status'];

            const rows = data.items.map(item => ({
                'Nazwa akcji': item.campaign,
                'Kod promocyjny': item.code,
                Status: 'pula została wyczerpana',
            }));

            return { promoCodesData: { headers, rows } };
        });

export const checkDiscountCode: CheckDiscountCodeType = async discountCode =>
    await fetch(DISCOUNT_CODE + discountCode).then(res => {
        if (!res.ok) {
            throw res.json();
        }

        return res.json();
    });

export const checkReferralCode: CheckReferralCodeType = async referralCode =>
    await fetch(CUSTOMER_REFERRALS + referralCode).then(res => {
        if (!res.ok) {
            throw res.json();
        }

        return res.json();
    });
